import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { CircularProgress } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { CheckBox, HideIcon, Move, PencilIcon, StyledTooltip, UserIcon } from '@room-match/shared-ui-components';
import React, { useEffect, useState } from 'react';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import { IAgencyTalentPermissionPayload } from 'shared/interfaces/IProfile';
import noImg from '../../../../no-image.png';
import { CheckNumberCont, DragCont, EditCont, ImageElement, ImageItemCont, useStyles } from './item.styles';
interface Props {
  idx?: number;
  check?: boolean;
  checkReturn?: (id: any) => void;
  onClick?: (idx: number) => void;
  checked?: boolean;
  img: any;
  src: string;
  isPrimary?: boolean;
  edit?: () => void;
  idToEdit?: string;
  isPatching?: boolean;
  handleAgencyTalentPermissions?: (payload: IAgencyTalentPermissionPayload) => void;
}

function ImageItem({
  idx,
  check,
  checkReturn,
  onClick,
  checked,
  img,
  src,
  isPrimary,
  edit,
  idToEdit,
  isPatching,
  handleAgencyTalentPermissions,
}: Props) {
  const classes = useStyles();
  const sortable = useSortable({ id: img.id });
  const { attributes, listeners, isDragging, setNodeRef, transform, transition } = sortable;
  const [show, setshow] = useState(false);
  const { width } = useWindowDimensions();
  const [source, setsource] = useState<string>(src);
  const [imgLoaded, setimgLoaded] = useState(false);
  const [isEditing, setisEditing] = useState(false);

  const checkClick = (e: any) => {
    e.stopPropagation();
    if (checkReturn) checkReturn(img);
  };
  const patching = idToEdit === (img.type === 'medium' ? img.id : img.attributes.medium_id) && isPatching;

  useEffect(() => {
    setisEditing(idToEdit === (img.type === 'medium' ? img.id : img.attributes.medium_id));
  }, [img, idToEdit]);

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform && { ...transform, scaleX: 1, scaleY: 1 }),
    transition,
    opacity: isDragging ? 0 : 1,
    filter: patching ? 'brightness(0.5)' : 'none',
    minWidth: 90,
  };

  useEffect(() => {
    setsource(src);
  }, [src]);

  const onEdit = (e: any) => {
    e.stopPropagation();
    if (edit) {
      setisEditing(true);
      edit();
    }
  };

  return (
    <ImageItemCont
      // style={{ width: width && width, height: height && height }}
      onClick={() => onClick && onClick(idx || 0 + 1)}
      style={style}
      onMouseOver={() => setshow(true)}
      onMouseLeave={() => setshow(false)}
    >
      {img?.attributes?.primary || isPrimary ? (
        <CheckNumberCont style={{ position: 'absolute', top: 5, left: 5, zIndex: 2 }}>
          <UserIcon fill="white" style={{ width: 14, height: 14 }} />
        </CheckNumberCont>
      ) : check ? (
        <div style={{ position: 'absolute', top: -5, left: -5 }}>
          <CheckBox checked={checked} onClick={checkClick} />
        </div>
      ) : idx ? (
        <>
          {width > 960 ? (
            <CheckNumberCont style={{ position: 'absolute', top: 5, left: 5, zIndex: 2 }} onClick={checkClick}>
              {show ? <HideIcon style={{ width: 18, height: 18, cursor: 'pointer' }} /> : idx}
            </CheckNumberCont>
          ) : (
            <>
              <CheckNumberCont style={{ position: 'absolute', top: 5, left: 5, zIndex: 2 }} onClick={checkClick}>
                {idx}
              </CheckNumberCont>
              <CheckNumberCont style={{ position: 'absolute', top: 33, left: 5, zIndex: 2 }} onClick={checkClick}>
                <HideIcon style={{ width: 18, height: 18, cursor: 'pointer' }} />
              </CheckNumberCont>
            </>
          )}
        </>
      ) : (
        <></>
      )}
      {!check && (show || width < 960) && !img?.attributes?.primary && (
        <DragCont {...attributes} {...listeners} className="img-item-hover">
          <Move viewBox="0 0 16 16" style={{ width: 18, height: 18 }} />
          {/* <DragIcon /> */}
        </DragCont>
      )}
      {(show || width < 960) && !patching ? (
        <StyledTooltip title={'Edit Image'} classes={{ tooltip: classes.toolTip }}>
          <EditCont onClick={onEdit}>
            {isEditing ? (
              <CircularProgress size={15} style={{ color: 'white' }} />
            ) : (
              <PencilIcon htmlColor="white" style={{ width: 15, height: 15 }} />
            )}
          </EditCont>
        </StyledTooltip>
      ) : (
        <React.Fragment />
      )}
      {patching ? <CircularProgress size={35} style={{ position: 'absolute' }} /> : <React.Fragment />}
      <ImageElement
        // style={{ width: img.attributes.file_width || img.attributes.medium_width }}
        draggable={false}
        ref={setNodeRef}
        // src={source}
        src={`${source}/0x144?reinvalidate${new Date().getTime()}`}
        onError={() => setsource(noImg)}
        style={{
          opacity: imgLoaded ? 1 : 0,
        }}
        onLoad={() => setimgLoaded(true)}
      />
      {!imgLoaded && (
        <Skeleton
          variant="rect"
          // animation="wave"
          width={90}
          height={144}
          style={{ position: 'absolute', borderRadius: 5, zIndex: 10 }}
        />
      )}
    </ImageItemCont>
  );
}

export default ImageItem;
